import { useState, useEffect } from 'react';
import { perfEnd, perfStart } from '../utils/perf';
import { safeGetJSON, safeSetJSON } from '../utils/safeStorage';

const FAVORITES_KEY = '@sixpass:favorites';

export function useFavorites() {
  const [favorites, setFavorites] = useState<string[]>([]);

  useEffect(() => {
    perfStart('favorites:load');
    // safeGetJSON nunca lança — se storage estiver cheio/indisponível,
    // cai no fallback `[]` e o app segue funcionando sem favoritos.
    const loaded = safeGetJSON<string[]>(FAVORITES_KEY, []);
    setFavorites(Array.isArray(loaded) ? loaded : []);
    perfEnd('favorites:load', 'favorites loaded');
  }, []);

  const toggleFavorite = (id: string) => {
    setFavorites((prev) => {
      const newFavs = prev.includes(id) ? prev.filter((fId) => fId !== id) : [...prev, id];
      // Tenta persistir; se falhar (storage cheio), favorito ainda fica em
      // memória pra essa sessão — o usuário não percebe nada, só vai perder
      // no próximo refresh.
      safeSetJSON(FAVORITES_KEY, newFavs);
      return newFavs;
    });
  };

  const isFavorite = (id: string) => favorites.includes(id);

  return { favorites, toggleFavorite, isFavorite };
}
